import {Component, Input, OnInit, ViewChild, ViewEncapsulation} from "@angular/core";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {MainService} from "src/app/Services/service.service";
import {DTOAdvertisement, DTOAdvertisementCategory, DTOEmoji, DTORegion, DTOSubRegion, FileResponse, AddPremiumAdTokenResponse, AddThirdPartyAdTokenResponse, AdvertistmentRepostModel} from "src/app/api/WickedApiClient";
import {ActivatedRoute, Router} from "@angular/router";
// import { UploadFileComponent } from 'src/app/Components/upload-file/upload-file.component';
import {UploadFileQueueComponent} from "src/app/Components/upload-file-queue/upload-file-queue.component";
import {HttpClient, HttpEvent, HttpEventType, HttpHeaders, HttpParams, HttpResponse} from "@angular/common/http";
import {FileInfo, UploadResponse} from "src/app/Models/FileModels";
import {getAuthToken} from "src/app/api/AuthHeaders";
import {CdkDragDrop, CdkDragEnter, moveItemInArray} from "@angular/cdk/drag-drop";
import {DTOAdvertisementEx} from "src/app/api/LocalModels";
import * as moment from "moment";
import {CaptchaService} from "../../Services/captcha.service";
import {ConfirmationResult} from "../../Messages/confirm-sheet/confirmation-sheet.component";
import {MatSelectChange} from "@angular/material";
import {UserService} from "../../Services/user.service";
import {removeEmojis} from "../../Helpers/EmojiHelper";
import {DEFAULT_DROPZONE_CONFIG} from "../../Helpers/DropzoneHeper";
import {SubscribtionService} from "../../Services/subscribtion.service";
import {debounceTime} from 'rxjs/operators';
import {PremiumAdTokenPayment} from "../../Components/premium-ad-token/premium-ad-token-paymen.component";
import {GeolocationService} from "../../Services/geolocation.service";
import {PreviousRouteService} from "../../Services/previousroute.service";
import {min} from "lodash";
import {environment} from "src/environments/environment";


export enum AdView {Advertisement = 0, Payment = 1}
export enum AdType {Free = 0, Premium = 1, ThirdParty = 2}

@Component({
  selector: "app-adv-edit",
  templateUrl: "./adv-edit.component.html",
  encapsulation: ViewEncapsulation.None,
  styleUrls: ["./adv-edit.component.scss"]
})
export class AdvEditComponent implements OnInit {

  @ViewChild(PremiumAdTokenPayment, {static: false, read: false}) adTokenPaymentForm: PremiumAdTokenPayment;

  private _captchaResolvedFlag = false;
  private currentTitleCursorPosition: number = -1;
  private currentDescriptionCursorPosition: number = -1;

  @Input() private _adView: AdView = AdView.Advertisement;
  @Input() private _adType: AdType = AdType.Free;
  @Input() _advId: string = null;

  private _userPremiumAdTokens: number = 0;
  private _userThirdPartyAdTokens: number = 0;

  personTypes = [{text: "I'm a Woman", value: "Woman"}, {text: "I'm a Man", value: "Man"}, {text: "I'm a Transgender", value: "Trans"}, {text: "We are a Couple", value: "Couple"}];
  private personTypesMap = {
    "Woman": [1, 2, 3, 4, 17],
    "Man": [5, 6, 7, 8, 17],
    "Trans": [13, 14, 15, 16, 17],
    "Couple": [9, 10, 11, 12, 17],
  }

  displayTexts = {
    1: "seeking Men",
    2: "seeking Women",
    3: "seeking Couples",
    4: "seeking Transgenders",
    5: "seeking Women",
    6: "seeking Men",
    7: "seeking Couples",
    8: "seeking Transgenders",
    9: "seeking Women",
    10: "seeking Men",
    11: "seeking Couples",
    12: "seeking Transgenders",
    13: "seeking Women",
    14: "seeking Men",
    15: "seeking Couples",
    16: "seeking Transgenders",
    17: "Missed Connections",
  }

  selectedPersonType: string = "";

  public advForm: FormGroup;
  public regionFilter: FormControl = new FormControl();
  public subregionFilter: FormControl = new FormControl();

  categories: DTOAdvertisementCategory[] = [];
  regions: DTORegion[] = [];
  subRegions: DTOSubRegion[] = [];

  images: FileInfo[] = [];

  constructor(public captchaService: CaptchaService, private HttpClient: HttpClient, private fb: FormBuilder,
    public services: MainService, private route: ActivatedRoute, private subscriptionService: SubscribtionService, private geolocationService: GeolocationService, private previouseRouteService: PreviousRouteService, private router: Router
  ) {

  }

  ngOnInit() {
    if(this._adType != 2) {
      this.subscriptionService.GetUserPremiumAdTokens().then(response => {
        this._userPremiumAdTokens = response;
        if(this._userPremiumAdTokens > 0 && this.isNew()) {
          this._adType = AdType.Premium;
        }
      });
    } else {
      this.subscriptionService.GetUserThirdPartyAdTokens().then(response => {
        this._userThirdPartyAdTokens = response;
        if(this._userThirdPartyAdTokens > 0 && this.isNew()) {
          this._adType = AdType.ThirdParty;
          this._adView = 0;
        }
      });
    }

    this.advForm = this.fb.group({
      region: [null, this.isThirdPartyAd ? null : Validators.required],
      subregion: [null, this.isThirdPartyAd ? null : Validators.required],
      postalCode: [null, this.isThirdPartyAd ? null : Validators.compose([Validators.required, Validators.minLength(5), Validators.maxLength(5)])],
      casualDating: ["true"],
      relationShips: [null],
      title: [null, Validators.required],
      content: [null],
      nick: [null, Validators.required],
      publish: [true],
      locationDescription: [null],
      termAccepted: [false],
      age: [null],
      selectedPersonType: [null, this.isThirdPartyAd ? null : Validators.required]
    });

    this.advForm.get("postalCode").valueChanges.pipe(debounceTime(1000)).subscribe((val: string) => {
      this.geolocationService.GetSubregionByZIP(val).then((response) => {
        if(response) {
          this.subRegions = this.services.advService.getSubRegionsByRegionId(response.regionId);
          this.advForm.get("region").patchValue(response.regionId);
          this.advForm.get("subregion").patchValue(response.subRegionId);
        } else {
          this.advForm.get("region").patchValue(null);
          this.advForm.get("subregion").patchValue(null);
        }
      });
    });

    if(!this.isPremiumFunctionality) {

      this.advForm.get('nick').valueChanges.subscribe(val => {
        if(!this.isPremiumAd) {
          this.advForm.get("nick").patchValue(removeEmojis(val), {onlySelf: true, emitEvent: false, emitModelToViewChange: true});
        }

      });

      this.advForm.get('content').valueChanges.subscribe(val => {
        if(!this.isPremiumAd) {
          this.advForm.get("content").patchValue(removeEmojis(val), {onlySelf: true, emitEvent: false, emitModelToViewChange: true});
        }
      });

      this.advForm.get('title').valueChanges.subscribe(val => {
        if(!this.isPremiumAd) {
          this.advForm.get("title").patchValue(removeEmojis(val), {onlySelf: true, emitEvent: false, emitModelToViewChange: true});
        }
      });

      this.advForm.get('age').valueChanges.subscribe(val => {
        if(!this.isPremiumAd) {
          this.advForm.get("age").patchValue(removeEmojis(val), {onlySelf: true, emitEvent: false, emitModelToViewChange: true});
        }
      });
    }
    let advId = Number(this.route.snapshot.paramMap.get("id"));

    this.services.advService.getCategories().then(r => {
      this.categories = r;
      this.regions = this.services.advService.getRegionsOnly();

      if(!isNaN(advId) && advId > 0) {
        this.get(advId);
      }
    });

    this.services.emojiService.emojis.then(result => {
      this.emojis = result;
    });
    this.services.hideLoader(true);
    window.scroll(0, 0)
  }

  categoryDisplayName(categoryId: number) {
    var category = this.categories.find(cat => cat.advertisementCategoryId == categoryId);
    if(category == null) {
      return "";
    }

    if(this.isNew() || true) {
      return this.displayTexts[categoryId] != null ? this.displayTexts[categoryId] : "";
    } else {
      return category.name;
    }

  }

  get filteredCategories(): DTOAdvertisementCategory[] {
    let categories = this.categories;
    if(this.selectedPersonType != "" && this.selectedPersonType in this.personTypesMap) {
      categories = this.categories.filter(cat => this.personTypesMap[this.selectedPersonType].indexOf(cat.advertisementCategoryId) > -1);
    } else if(this.isNew()) {
      categories = [];
    }

    return categories;
  }

  get isPremiumAd(): boolean {
    if(this.adv == null) {
      return this._adType == AdType.Premium
    } else {
      return this.adv.isPremium || this._adType == AdType.Premium;
    }
  }

  get isThirdPartyAd(): boolean {
    if(this.adv == null) {
      return this._adType == AdType.ThirdParty
    } else {
      return this.adv.isThirdParty || this._adType == AdType.ThirdParty;
    }
  }

  private _specialUser: boolean = null;
  get SpecialUser(): boolean {
    if(this._specialUser == null) {
      this._specialUser = this.services.userService.isAdmin() || this.services.userService.isDemo() || this.services.userService.isPremium();
    }
    return this._specialUser;
  }

  get isPremiumFunctionality(): boolean {
    return this.isPremiumAd || this.SpecialUser
  }

  get isThirdPartyFunctionality(): boolean {
    return this.isThirdPartyAd
  }

  get AdType(): AdType {
    return this._adType;
  }

  private _isUserDemo: boolean = null;
  get isUserDemo(): boolean {
    if(this._isUserDemo == null) {
      this._isUserDemo = this.services.userService.isDemo();
    }
    return this._isUserDemo;
  }

  private _isUserAdmin: boolean = null;
  get isUserAdmin(): boolean {
    if(this._isUserAdmin == null) {
      this._isUserAdmin = this.services.userService.isAdmin();
    }

    return this._isUserAdmin;
  }


  get isUserPremium(): boolean {
    return this.services.userService.isPremium();
  }

  get HasUserPremiumAdToken(): boolean {
    return this._userPremiumAdTokens > 0;
  }

  get UserPremiumAdToken(): number {
    return this._userPremiumAdTokens;
  }

  get HasUserThirdPartyAdToken(): boolean {
    return this._userThirdPartyAdTokens > 0;
  }

  get UserThirdPartyAdToken(): number {
    return this._userThirdPartyAdTokens;
  }


  get AdView(): AdView {
    return this._adView
  }

  set AdView(value: AdView) {
    this._adView = value;
  }


  get submitInProgress(): boolean {
    return this._submitInProgress;
  }

  set submitInProgress(value: boolean) {
    this._submitInProgress = value;
  }

  private _selectedImage: FileInfo;
  public get selectedImage(): FileInfo {
    return this._selectedImage;
  }

  private _isDemoAd: boolean = false;
  public get IsDemoAd(): boolean {
    return this._isDemoAd;
  }

  public set selectedImage(value: FileInfo) {
    if(value != this._selectedImage) {
      this.imagesChanged = true;
    }
    this._selectedImage = value;
  }

  adv: DTOAdvertisementEx;

  @ViewChild("fileUploadQueue", {static: true}) fileUploadQueue: UploadFileQueueComponent; This: any = this;

  imagesChanged: boolean = false;

  changeAdType(e) {
    this._adType = e.value;
    if(this._adType == AdType.Premium && this.UserPremiumAdToken == 0) {
      this.AdView = AdView.Payment
    } else {
      this.AdView = AdView.Advertisement
    }

    if(this._adType == AdType.Free) {
      this.clearPremiumElements();
    }
  }

  clearPremiumElements() {
    this.advForm.get("content").patchValue(removeEmojis(this.advForm.get("content").value), {onlySelf: true, emitEvent: false, emitModelToViewChange: true});
    this.advForm.get("title").patchValue(removeEmojis(this.advForm.get("title").value), {onlySelf: true, emitEvent: false, emitModelToViewChange: true});
    if(this.images.length > 1) {
      this.images = [this.images[0]];
    }
  }



  onChanges(): void {
    this.advForm.get("subregion").valueChanges.subscribe((val: number) => {
      this.advForm.get("postalCode").patchValue(this.getZipCode(val), {onlySelf: true, emitEvent: false, emitModelToViewChange: true});
    });
  }

  onChangesSelect(e: MatSelectChange): void {
    this.advForm.get("postalCode").patchValue(this.getZipCode(e.value), {onlySelf: true, emitEvent: false, emitModelToViewChange: true});
  }



  getZipCode(subregionId: number) {
    let subregion = this.subRegions.find(x => x.subRegionId == subregionId);
    if(subregion) {
      return subregion.zip;
    }
    return "";
  }

  titleClick(e: MouseEvent) {
  }


  titleBlur(e: Event) {
    if(e.target['selectionStart'] != null) {
      this.currentTitleCursorPosition = e.target['selectionStart'] as number;
    }
  }

  descriptionBlur(e: Event) {
    if(e.target['selectionStart'] != null) {
      this.currentDescriptionCursorPosition = e.target['selectionStart'] as number;
    }
  }

  updateContent(text: string) {
    this.advForm.controls['content'].patchValue(text, {onlySelf: true, emitEvent: false, emitModelToViewChange: true});
  }

  updateTitle(text: string) {
    this.advForm.controls['title'].patchValue(text, {onlySelf: true, emitEvent: false, emitModelToViewChange: true});
  }

  get filteredSubregion(): DTOSubRegion[] {
    if(!this.subRegions) {
      return [];
    }
    let search = this.subregionFilter.value;
    if(!search) {
      return this.subRegions;
    } else {
      return this.subRegions.filter(r => r.name.toLowerCase().indexOf(search) > -1);
    }
  }

  get filteredRegions(): DTORegion[] {
    if(!this.regions) {
      return [];
    }
    let search = this.regionFilter.value;
    if(!search) {
      return this.regions;
    } else {
      return this.regions.filter(r => r.name.toLowerCase().indexOf(search) > -1);
    }
  }

  private controlNames: {name: string, title: string}[] = [
    {name: 'title', title: 'Title'},
    {name: 'nick', title: 'Nick'},
    {name: 'content', title: 'Description'},
    {name: 'age', title: 'Age'},
    {name: 'region', title: 'Region'},
    {name: 'subregion', title: 'Sub Region'},
    {name: 'postalcode', title: 'ZIP Code'},
    {name: 'casualDating', title: 'Casual dating'},
    {name: 'relationShips', title: 'Relationship'},
    {name: 'termAccepted', title: "Terms Accept"}
  ];

  private getInvalidFields(): string[] {
    const result = this.controlNames.map(control => {
      return {controlItem: control, control: this.advForm.controls[control.name]}
    }).filter(c => c.control != null && !c.control.valid);
    return result.map(c => c.controlItem.title);
  }

  addTitleEmoji(e: any) {
    let value = this.advForm.controls["title"].value;
    if(!value) {
      value = "";
    }
    if(this.currentTitleCursorPosition > -1 && value != "") {
      value = value.substring(0, this.currentTitleCursorPosition) + " " + e.emoji.native + " " + value.substring(this.currentTitleCursorPosition + 1, value.length)
    } else {
      value = e.emoji.native;
    }
    this.advForm.controls["title"].patchValue(value, {onlySelf: true, emitEvent: false, emitModelToViewChange: true});
  }

  addDescriptionEmoji(e: any) {
    let value = this.advForm.controls["content"].value;
    if(!value) {
      value = "";
    }
    if(this.currentDescriptionCursorPosition > -1 && value != "") {
      value = value.substring(0, this.currentDescriptionCursorPosition) + " " + e.emoji.native + " " + value.substring(this.currentDescriptionCursorPosition + 1, value.length)
    } else {
      value = e.emoji.native;
    }
    this.advForm.controls["content"].patchValue(value, {onlySelf: true, emitEvent: false, emitModelToViewChange: true});
  }

  addNewTitleEmoji(e: any) {

    if(e instanceof DTOEmoji) {
      let emojiCode: any = e.code;
      let value = this.advForm.controls["title"].value;
      if(!value) {
        value = "";
      }
      if(this.currentTitleCursorPosition > -1 && value != "") {
        value = value.substring(0, this.currentTitleCursorPosition) + " " + emojiCode + " " + value.substring(this.currentTitleCursorPosition + 1, value.length)
      } else {
        value = emojiCode;
      }
      this.advForm.controls["title"].setValue(value);
    }

  }


  addNewDescriptionEmoji(e: any) {
    if(e instanceof DTOEmoji) {

      let emojiCode: any = e.code;
      let value = this.advForm.controls["content"].value;
      if(!value) {
        value = "";
      }
      if(this.currentDescriptionCursorPosition > -1 && value != "") {
        value = value.substring(0, this.currentDescriptionCursorPosition) + " " + emojiCode + " " + value.substring(this.currentDescriptionCursorPosition + 1, value.length)
      } else {
        value = emojiCode;
      }
      this.advForm.controls["content"].patchValue(value, {onlySelf: true, emitEvent: false, emitModelToViewChange: true});
    }

  }

  private advIsLoading = false;



  get(advId: number) {
    if(!this.advIsLoading) {
      this.advIsLoading = true;

      var advertisement = this.services.advService.searchDataUserAdv.resultList.find(a => a.advertisementId == advId);
      if(advertisement != null) {
        this.bindAdvertisementToForm(advertisement);
      } else {
        this.services.advService.getAdvertisementData(advId).then(r => {
          if(r && r.adveristments && r.adveristments.length == 1) {
            if(r.adveristments[0].userId != this.services.userService.getUserId() && !this.isUserAdmin) {
              this.services.route.navigate([""]);
            } else {
              this.bindAdvertisementToForm(r.adveristments[0]);
            }
          } else {
            this.services.route.navigate([""]);
          }
          this.advIsLoading = false;
        }).catch(err => {
          this.services.showError(err);
          this.advIsLoading = false;
        });
      }


    }
  }

  public bindAdvertisementToForm(dto: DTOAdvertisement) {
    this.adv = new DTOAdvertisementEx();
    this.adv.init(dto);
    this.advForm.setValue({
      title: this.adv.title,
      content: this.adv.content,
      locationDescription: this.adv.locationDescription,
      age: this.adv.age,
      nick: this.adv.userNick,
      region: this.adv.regionId,
      subregion: this.adv.subRegionId,
      postalCode: this.adv.zipCode,
      casualDating: this.adv.casualDating ? "true" : "false",
      publish: this.adv.published ? "true" : "false",
      selectedPersonType: this.getPersonTypeByCategory(this.adv.advertisementCategoryId),
      termAccepted: false,
      relationShips: this.adv.advertisementCategoryId,
    });

    this.selectedPersonType = this.getPersonTypeByCategory(this.adv.advertisementCategoryId);

    //this.advForm.controls["relationShips"].setValue(this.adv.advertisementCategoryId);

    this.images = (this.adv.images || []).map(img => {
      var fi: FileInfo = new FileInfo();
      fi.init(img);
      return fi;
    });


    this.setSelectedRegion(this.adv.regionId, true);

    this.images.sort((a, b) => {
      return a.orderIndex > b.orderIndex ? 1 : a.orderIndex < b.orderIndex ? -1 : 0;
    });

    this.updateImageIndexes();
    if(this.images && this.images.length > 0) {
      this.selectedImage = this.images[0];
    }
    this.imagesChanged = false;

    this._adType = dto.isPremium ? AdType.Premium : (dto.isThirdParty ? AdType.ThirdParty : AdType.Free);
    this._isDemoAd = dto.isDemo;
    this._isExpired = !dto.isDemo && this.adv.dateStart && this.adv.dateStart.isSameOrBefore(moment().subtract(14, 'day'));

    this.advForm.controls["selectedPersonType"].clearValidators();
    this.advForm.controls["selectedPersonType"].updateValueAndValidity();


    if(dto.isDemo) {
      this.advForm.controls["subregion"].clearValidators();
      this.advForm.controls["subregion"].updateValueAndValidity();
      this.advForm.controls["region"].clearValidators();
      this.advForm.controls["region"].updateValueAndValidity();

      this.advForm.controls["postalCode"].clearValidators();
      this.advForm.controls["postalCode"].updateValueAndValidity();
    }

  }

  isMaxImagesExeeded(): boolean {
    if(this.isPremiumFunctionality || this.isThirdPartyAd) {
      return this.images.length >= 10;
    } else {
      return this.images.length >= 1;
    }
  }

  setSelectedRegion(regionId: any, binding: boolean = false) {
    if(regionId) {
      // let rg = this.regions.filter(r => r.regionId == regionId);
      this.subRegions = this.services.advService.getSubRegionsByRegionId(regionId);
      if(this.adv) {
        this.advForm.controls["subregion"].patchValue(binding ? this.adv.subRegionId : null, {onlySelf: true, emitEvent: false, emitModelToViewChange: true});
      } else {
        this.advForm.controls["subregion"].patchValue(null, {onlySelf: true, emitEvent: false, emitModelToViewChange: true});
      }
    }
  }

  private updateImageIndexes() {
    this.images.forEach((img, index) => {
      img.orderIndex = index;
    });
  }

  drop(event: CdkDragDrop<FileInfo[]>) {
    if(event.previousIndex != event.currentIndex) {
      moveItemInArray(this.images, event.previousIndex, event.currentIndex);
      this.updateImageIndexes();
      this.imagesChanged = true;
    }
  }

  isNew() {
    let adId = Number(this.route.snapshot.paramMap.get("id"));
    return isNaN(adId) || adId == 0;
  }


  private _isExpired: boolean = false;
  public get Expired(): boolean {
    return this._isExpired;
  }

  onTokenAdded(response: AddPremiumAdTokenResponse, thirdParty: boolean = false) {
    if(response.isError) {
      this.services.showError(response.message ? response.message : "Payment process error.");
    } else if(thirdParty) {
      this._adView = AdView.Advertisement;
      this._userThirdPartyAdTokens += 1;
    } else {
      this._adView = AdView.Advertisement;
      this._userPremiumAdTokens += 1;
    }
  }


  adminRedirect() {
    if(this.previouseRouteService.getPreviousUrl() != this.router.url) {
      this.services.route.navigate([this.previouseRouteService.getPreviousUrl()]);
    } else {
      this.services.route.navigate(["search-results"]);
    }
  }

  repostAd() {
    var repostModel = new AdvertistmentRepostModel();;
    repostModel.init({
      manageId: this._manageId,
      advertisementId: this.adv.advertisementId,
      userId: this.adv.userId,
      userNick: this.advForm.controls["nick"].value,
      advertisementCategoryId: this.AdType != AdType.ThirdParty ? Number(this.advForm.controls["relationShips"].value) : 1,
      casualDating: this.advForm.controls["casualDating"].value == "true",
      content: this.advForm.controls["content"].value,
      images: this.images,
      published: this.advForm.controls["publish"].value == "true",
      regionId: Number(this.advForm.controls["region"].value),
      subRegionId: Number(this.advForm.controls["subregion"].value),
      title: this.advForm.controls["title"].value,
      age: this.advForm.controls["age"].value ? (this.advForm.controls["age"].value + "") : null,
      seen: false,
      seenAdmin: false,
      isPremium: AdType.Premium ? true : false,
      isThirdParty: AdType.ThirdParty ? true : false,
      zipCode: this.advForm.controls["postalCode"].value,
      isDemo: false
    });


    this.services.advService
      .repost(repostModel)
      .then(response => {
        this.submitInProgress = false;
        if(response.isReposted) {
          if(this.isUserAdmin && !this.isNew()) {
            this.adminRedirect();
          }
          else {
            this.services.route.navigate(["my-ads"]);
          }

        }
      })
      .catch(e => {
        this.submitInProgress = false;
        this.services.showError(e);
      });

  }


  onSubmit() {
    if(!this.captchaValid()) {
      this.services.showError("Check captcha");
      return false;
    }
    console.log(this.advForm.valid);
    if(!this.advForm.valid) {
      window.scrollTo(0, 0);
      this.services.showError("Some fields are invalid, fill them properly: " + this.getInvalidFields().join(","));
      return false;
    }

    this.submitInProgress = true;
    //repost ADV
    if(this.advForm.valid && this.Expired) {
      if(this.AdType == AdType.Premium && !this.SpecialUser) {
        if(!this.HasUserPremiumAdToken && !this.adTokenPaymentForm.form.valid) {
          this.submitInProgress = false;
          return;
        }

        if(this.HasUserPremiumAdToken) {
          this.repostAd();
        }
        else {
          this.adTokenPaymentForm.onTokenAdded.subscribe((response: AddPremiumAdTokenResponse) => {
            if(response.isCreated) {
              this.repostAd();
            } else {
              this.services.showError(response.message ? response.message : "Your payment could not be processed, please contact your bank for details.");
              this.submitInProgress = false;
            }
          });
          this.adTokenPaymentForm.onSubmit();
        }

      } else if(this.AdType == AdType.ThirdParty) {
        if(!this.HasUserThirdPartyAdToken && !this.adTokenPaymentForm.form.valid) {
          this.submitInProgress = false;
          return;
        }

        if(this.HasUserThirdPartyAdToken) {
          this.repostAd();
        }
        else {
          this.adTokenPaymentForm.onTokenAdded.subscribe((response: AddThirdPartyAdTokenResponse) => {
            if(response.isCreated) {
              this.repostAd();
            } else {
              this.services.showError(response.message ? response.message : "Your payment could not be processed, please contact your bank for details.");
              this.submitInProgress = false;
            }
          });
          this.adTokenPaymentForm.onSubmit();
        }

      } else {
        this.repostAd()
      }
    } else if(this.advForm.valid) {
      if(this.adv) {
        // update ADV
        if(this.selectedImage) {
          const index = this.images.indexOf(this.selectedImage);
          moveItemInArray(this.images, index, 0);
          this.images.forEach((img, index) => {
            img.orderIndex = index;
            img.isMain = false;
          });
          this.images[0].isMain = true;
        }

        this.services.advService
          .update(
            this._manageId,
            this.adv.advertisementId,
            this.adv.userId,
            this.advForm.controls["nick"].value,
            this.advForm.controls["title"].value,
            this.advForm.controls["content"].value,

            Number(this.advForm.controls["region"].value),
            Number(this.advForm.controls["subregion"].value),
            this.advForm.controls["postalCode"].value,
            this.advForm.controls["casualDating"].value == "true",
            this.AdType != AdType.ThirdParty ? Number(this.advForm.controls["relationShips"].value) : 1,
            this.advForm.controls["publish"].value == "true",
            this.advForm.controls["age"].value ? (this.advForm.controls["age"].value + "") : null,
            this.images,
            this.AdType == AdType.Premium ? true : false,
            this.AdType == AdType.ThirdParty ? true : false,
          )
          .then(r => {
            this.submitInProgress = false;
            if(this._manageId == null) {
              if(this.isUserAdmin) {
                this.adminRedirect();
              } else {
                this.services.route.navigate(["my-ads"]);
              }

            } else {
              this.services.route.navigate([""])
            }
          })
          .catch(e => {
            this.submitInProgress = false;
            this.services.showError(e);
          });
      } else {
        // create ADV
        this.services.advService
          .create(
            this.advForm.controls["nick"].value,
            this.advForm.controls["title"].value,
            this.advForm.controls["content"].value,
            Number(this.advForm.controls["region"].value),
            Number(this.advForm.controls["subregion"].value),
            this.advForm.controls["postalCode"].value,
            this.advForm.controls["casualDating"].value == "true",
            this.AdType != AdType.ThirdParty ? Number(this.advForm.controls["relationShips"].value) : 1,
            this.advForm.controls["publish"].value == "true",
            this.advForm.controls["age"].value ? (this.advForm.controls["age"].value + "") : null,
            this.images,
            this.AdType == AdType.Premium ? true : false,
            this.AdType == AdType.ThirdParty ? true : false,
          )
          .then(r => {
            this.submitInProgress = false;
            this.services.showThxDialog("my-ads");
          })
          .catch(e => {
            this.submitInProgress = false;
            this.services.showError(e);
          });
      }
    }
  }

  isImage(file: File) {
    let name = file.name.toLowerCase();
    return name.endsWith(".jpg") || name.endsWith(".gif") || name.endsWith(".png") || name.endsWith(".jpeg") || name.endsWith(".bmp");
  }

  uploadFile(file: FileInfo) {
    var url = "/File/TemporaryUpload";
    let formData = new FormData();
    let token = getAuthToken();
    var headers = new HttpHeaders(); //.set('Content-Type', 'multipart/form-data');
    var httpRequestParams = new HttpParams();
    headers.set("Authorization", "Bearer " + token);
    formData.set("file", file.file, file.file.name);
    this.services.progress = true;
    this.HttpClient.post(url, formData, {
      headers: headers,
      observe: "events",
      params: httpRequestParams,
      reportProgress: true,
      responseType: "json"
    }).subscribe(
      (event: HttpEvent<Object>) => {
        if(event.type === HttpEventType.UploadProgress) {
          file.progressPercentage = Math.floor((event.loaded * 100) / event.total);
          file.loaded = event.loaded;
        }
        if(event.type == HttpEventType.Response) {
          var eventResponse = <HttpResponse<UploadResponse>>event;
          if(eventResponse.body && eventResponse.ok) {
            file.fileName = eventResponse.body.files[0].localFilename;
            file.isUploading = false;
            file.imageUrl = `${environment.apiBaseUrl}/FileGet/${file.fileName}`;
          }
          this.services.progress = false;
        }
      },
      (error: any) => {
        file.isUploading = false;
        this.services.progress = false;
      },
      () => {
      }
    );
  }

  getPersonTypeByCategory(categoryId: number): string {
    let type: string = "";
    Object.keys(this.personTypesMap).forEach((personType) => {
      if(this.personTypesMap[personType].indexOf(categoryId) > -1) {
        type = personType;
      }
    });


    return type;
  }

  addFile(file: File) {

    if(this.isImage(file)) {
      var fi = new FileInfo();
      fi.file = file;
      fi.fileName = file.name;
      fi.name = file.name;
      fi.orgFileName = file.name;
      fi.advertisementId = this.adv ? this.adv.advertisementId : null;
      var reader = new FileReader();
      reader.onload = e => {
        if(this.isMaxImagesExeeded()) {
          return;
        }

        fi.imageUrl = <string>reader.result;
        this.images.push(fi);
        this.updateImageIndexes();
        this.uploadFile(fi);
        if(!this.selectedImage) {
          this.selectedImage = fi;
        }
        this.imagesChanged = true;
      };
      reader.readAsDataURL(fi.file);
    }
  }

  deleteImage(file: FileInfo) {
    this.images = this.images.filter(x => x.orderIndex != file.orderIndex);
    this.images.forEach((img, index) => {
      img.orderIndex = index;
    });

    if(this.selectedImage == file) {
      if(this.images.length > 0) {
        this.selectedImage = this.images[0];
      } else {
        this.selectedImage = undefined;
      }
      //  this.selectedImage =
    }

    this.imagesChanged = true;
  }

  cdkDragStarted(event, childItem, i) {

  }

  cdkDragReleased(event, childItem, i) {

  }

  overAction(i) {

  }

  entered(event: CdkDragEnter<string[]>) {

  }

  private _submitDisabled: boolean;
  private _manageId: string;

  private _submitInProgress: boolean = false;

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if(control instanceof FormControl) {
        control.markAsTouched({onlySelf: true});
      } else if(control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  bindAdvertisement(dto: DTOAdvertisement, manageId: string) {
    this._manageId = manageId;
    this.bindAdvertisementToForm(dto);
  }

  emojis: DTOEmoji[] = [];

  tryDeleteAd() {
    this.services.showConfirm("Are you sure you want to delete this ad? You won't be able to restore it.").then((res) => {
      if(res == ConfirmationResult.Yes) {
        this.services.advService.delete(this.adv.advertisementId).then(res => {
          this.services.showInformation("Your ad was deleted");
          if(this.isUserAdmin) {
            this.adminRedirect();
          }
          else {
            this.services.route.navigate(["my-ads"]);
          }
        }).catch(err => {
          this.services.showError(err)
        })
      }
    })
  }

  onDropzoneUploadSuccess(event: any[]) {
    let file: File = event[0];
    let response = event[1];
    if(this.isImage(file)) {
      var fi = new FileInfo();
      fi.file = file;
      fi.fileName = file.name;
      fi.name = file.name;
      fi.orgFileName = file.name;
      fi.advertisementId = this.adv ? this.adv.advertisementId : null;
      fi.imageUrl = `${environment.apiBaseUrl}/FileGet/${response.files[0].localFilename}`

      this.images.push(fi);
      this.updateImageIndexes();
      //this.uploadFile(fi);
      if(!this.selectedImage) {
        this.selectedImage = fi;
      }
      this.imagesChanged = true;
    }
  }

  onUploadError(event: any) {

  }


  private _dragOn: boolean = false;
  get dragOn(): boolean {
    return this._dragOn;
  }

  dragleave(event: any) {
    this._dragOn = false;
  }

  dragover(event: any) {
    this._dragOn = false;
  }

  dragenter(event: any) {
    this._dragOn = false;
  }

  get dropzoneConfig() {
    return DEFAULT_DROPZONE_CONFIG;
  }

  private _termsNotAccepted: boolean = true;
  public get termsNotAccepted(): boolean {
    return this._termsNotAccepted;
  }
  public set termsNotAccepted(value: boolean) {
    this._termsNotAccepted = value;
  }

  getCaptchaResolvedFlag(): boolean {
    return this._captchaResolvedFlag;
  }

  setCaptchaResolvedFlag(value) {
    this._captchaResolvedFlag = value;
  }

  captchaAvailable() {
    return (this.captchaService.getCurrentCaptchaKey() != "");
  }

  captchaResolved(captchaResponse: string) {
    this.setCaptchaResolvedFlag(true)
  }

  public termsAcceptAction(e) {
    this.termsNotAccepted = !e.checked
  }

  private captchaValid() {
    return !this.captchaAvailable() || (this.captchaAvailable() && this._captchaResolvedFlag)
  }
}
